const routePaths = {
  home: '/',
  landingPage: '/command-center',
  dashboard: '/dashboard',
  enterpriseDashboard: '/enterprise/dashboard',
  platformDashboard: '/dashboard/platform',
  reportsDashboard: '/reports',
  signIn: '/sign-in',
  ssoSignIn: '/sso',
  ssoTokenExchange: '/exchange',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password/',
  confirmInvite: '/confirm-invite/',
  registerInvitee: '/register-invitee/',
  logout: '/logout',
  changePassword: '/change-password',
  taxDashboard: '/tax',
  taxAbout: '/tax/about',
  taxReceipt: '/tax/receipt/',
  logTransaction: '/log/transaction',
  editTransaction: '/edit/transaction/',
  post: '/post/',
  marketplace: '/marketplace',
  myPosts: '/activity/my-posts',
  myClaims: '/activity/my-claims',
  myVerifications: '/activity/my-verifications',
  pendingVerifications: '/pending-verifications',
  userManagement: '/users',
  proxy: '/proxy/',
  items: '/items',
  itemCatalog: '/items/catalog',
  itemAbout: '/items/about',
  itemHistory: '/items/history',
  itemHistoryDetail: '/item/history/',
  itemImport: '/items/import/file',
  orgSettings: '/organization/settings',
  siteSettings: '/site/settings',
  inventory: '/inventory',
  staging: '/staging',
  review: '/review',
  offerReview: '/review/offers',
  donationImport: '/import-donations',
  addSite: '/administration/addsite',
  impersonate: '/administration/impersonate',
  supportSSO: '/support/sso',
  offerComparison: '/offer-comparison',
  trucklane: '/offer-comparison/trucklane',
  negotiations: '/negotiations',
  suggestedNegotiations: '/suggested-negotiations',
  history: '/history',
  notFound: '/404',
  error: '/error',
  transactions: '/transactions',
  customers: '/customers',
  buyerRoutes: {
    prefix: '/buyer',
    login: '/login',
    activeListings: '/active-listings',
    bids: '/bids/:transactionCycleId/:catalogId?',
    award: '/award/:transactionCycleId',
    insights: '/insights/:transactionCycleId',
    expiredCycle: '/expired',
    brokenLink: '/broken-link',
    suffix: '/:buyerAuthToken',
    notifications: '/notifications',
    orderHistory: '/order-history',
    logout: '/logout',
    settings: '/settings',
  },
  companyLogo: '/company-logo',
  buyerHome: '/buyer/active-listings',
};

export default routePaths;
